global.$ = global.jQuery = require('jquery');

// import './assets/scss/_variables.scss';
// import './assets/scss/_general.scss';
// import '../node_modules/bootstrap/scss/bootstrap.scss';

import 'vant/lib/index.css';

import Vue from 'vue'

import VueRouter from 'vue-router'
Vue.use(VueRouter)

import VueAnalytics from 'vue-analytics';

import 'es6-promise/auto'

import Vuex from 'vuex'
Vue.use(Vuex)

import { Dialog, Button } from 'vant';
Vue.use(Dialog)
Vue.use(Button)

import axios from './plugins/axios'
Vue.prototype.$axios = axios

import VueMeta from 'vue-meta'
Vue.use(VueMeta)

import store from './store/index'

import '@fortawesome/fontawesome-free/css/all.css'

import App from './App.vue'

Vue.config.productionTip = false

import routes from './router/routes'

const router = new VueRouter({
    mode: 'history',
    base: __dirname,
    store,
    routes, // short for `routes: routes`
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    }
});

Vue.use(VueAnalytics, {
    id: 'UA-18326695-1',
    router
});

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')

window.getStoreInstance = function() {
    return store;
};
